import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import React, { useEffect, useState, useRef } from "react";
import TextInput from "./TextInput";
import { TabPanel, TabView } from "primereact/tabview";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { eventService } from "../services/EventService";
import { delimitationService } from "../services/DelimitationService";
import { lookupsService } from "../services/LookupsService";
import { Toolbar } from "primereact/toolbar";
import ScreenLoader from "../componets/ScreenLoader";
import { changeLang } from "./Language/ChangeLang";

export default function AddEventDelimitationStaff({
	show = false,
	setShow,
	selectedEvent,
	form,
	setForm,
	onSubmit,
	formErrorMessage,
	setFormErrorMessage,
	OnInputValidation,
	setScreenLoading,
	screenLoading
}) {
	var [isSpecificDelimitation, setIsSpecificDelimitation] = useState(false);
	var [parentEvent, setParentEvent] = useState({});
	var [demarcationLevels, setDemarcationLevels] = useState([
		{ name: changeLang.get("national_delimitation.level1District"), delimitationLevelID: 1, type: "1" },
		{ name: changeLang.get("national_delimitation.level2ConstituencyCouncil"), delimitationLevelID: 2, type: "1" },
		{ name: changeLang.get("national_delimitation.level3PollingElectorDivision"), delimitationLevelID: 3, type: "1" },
		{ name: changeLang.get("national_delimitation.level4RegistrationCentre"), delimitationLevelID: 4, type: "1" },
		{ name: changeLang.get("national_delimitation.level6PollingStation"), delimitationLevelID: 6, type: "1" },

		{ name: changeLang.get("local_delimitation.level1District"), delimitationLevelID: 1, type: "2" },
		{ name: changeLang.get("local_delimitation.level2ConstituencyCouncil"), delimitationLevelID: 2, type: "2" },
		{ name: changeLang.get("local_delimitation.level3PollingElectorDivision"), delimitationLevelID: 3, type: "2" },
		{ name: changeLang.get("local_delimitation.level4RegistrationCentre"), delimitationLevelID: 4, type: "2" },
		{ name: changeLang.get("local_delimitation.level6PollingStation"), delimitationLevelID: 6, type: "2" }
	]);
	var [isSubmitAttempted, setIsSubmitAttempted] = useState(false);
	var [demarcationLevelForm, setDemarcationLevelForm] = useState({
		DelimitationLevelID: "",
		DistrictID: "",
		ConstituencyID: "",
		VotingDistictID: "",
		VotingStationID: "",
		PollingStationID: ""
	});
	var [demarcationLevelFormErr, setDemarcationLevelFormErr] = useState({
		DistrictID: "",
		ConstituencyID: "",
		VotingDistictID: "",
		VotingStationID: "",
		PollingStationID: ""
	});
	useEffect(() => {
		if (!show) {
			setDemarcationLevelForm({
				DelimitationLevelID: null,
				DistrictID: null,
				ConstituencyID: null,
				VotingDistictID: null,
				VotingStationID: null,
				PollingStationID: null
			});

			setDemarcationLevelFormErr({});
			setFormErrorMessage({});

			setIsSpecificDelimitation(false);
			setIsSubmitAttempted(false);
		}
	}, [show]);

	useEffect(() => {
		if (isSubmitAttempted) {
			DemarcationValidation();
		}
	}, [demarcationLevelForm]);
	var [distrcts, setDistrcts] = useState([]);
	var [constituences, setConstituences] = useState([]);
	var [votingDistricts, setVotingDistricts] = useState([]);
	var [votingStations, setVotingStations] = useState([]);
	var [polingStations, setPolingStations] = useState([]);

	const toast = useRef(null);

	const [lookups, setLookups] = useState({
		staffTypes: [],
		staffRoles: [],
		genders: []
	});
	useEffect(() => {
		if (show && selectedEvent?.eventDelimitationId) {
			setIsSpecificDelimitation(true);
			setForm((prevForm) => ({
				...prevForm,
				DelimitationID: selectedEvent?.eventDelimitationId,
				DelimitationLevelID: selectedEvent?.eventDelimitationLevelId
			}));
			if (selectedEvent?.eventTypeID == 1 || selectedEvent?.eventTypeID == 4) {
				GetPreselectedNationalDelimitationOnOpen(selectedEvent?.eventDelimitationId);
			} else if (selectedEvent?.eventTypeID == 2) {
				GetPreselectedLocalDelimitationOnOpen(selectedEvent?.eventDelimitationId);
			} else if (selectedEvent?.eventTypeID == 3) {
				GetByElectionParentEvent(selectedEvent?.eventDelimitationId);
			}
			setDemarcationLevelForm((prevForm) => ({ ...prevForm, DelimitationLevelID: selectedEvent?.eventDelimitationLevelId }));
		} else {
			GetDistricts();
		}

		// getDemarcationLevels();
		lookupsService
			.getAll()
			.then((data) => {
				//setLoading(false);
				setLookups({
					staffTypes: data.staffTypes,
					staffRoles: data.staffRoles,
					genders: data.genders
				});
			})
			.catch((error) => {
				console.error("Error fetching lookups:", error);
				//setLoading(false);
			});
	}, [show, selectedEvent]);

	function getDemarcationLevels() {
		eventService
			.getDemarcationLevels()
			.then((response) => {
				setDemarcationLevels(response);
			})
			.catch((err) => {});
	}
	function GetDistricts() {
		if (selectedEvent?.eventTypeID == 1 || selectedEvent?.eventTypeID == 4) {
			GetNationalDistricts();
		} else if (selectedEvent?.eventTypeID == 2) {
			GetLocalDistricts();
		} else if (selectedEvent?.eventTypeID == 3) {
			GetByElectionParentEvent(selectedEvent?.parentEventID);
		}
	}
	function GetNationalDistricts() {
		delimitationService
			.getDistricts()
			.then((response) => {
				setDistrcts(response);
				setDemarcationLevelForm((prevForm) => ({ ...prevForm, DelimitationID: 1 }));
			})
			.catch((err) => {});
	}
	function GetLocalDistricts() {
		delimitationService
			.getLocalDistricts()
			.then((response) => {
				setDistrcts(response);
			})
			.catch((err) => {});
	}

	function GetPreselectedNationalDelimitationOnOpen(id) {
		if (selectedEvent.eventDelimitationLevelId == 1) {
			GetNationalConstituencyByDistrictIdAsync(id);
			setDemarcationLevelForm((prevForm) => ({ ...prevForm, DistrictID: selectedEvent?.eventDelimitationId }));
		} else if (selectedEvent.eventDelimitationLevelId == 2) {
			GetVotingDistrictByConstituencyID(id);
			setDemarcationLevelForm((prevForm) => ({ ...prevForm, ConstituencyID: selectedEvent?.eventDelimitationId }));
		} else if (selectedEvent.eventDelimitationLevelId == 3) {
			GetVotingStationByVotingDistrictID(id);
			setDemarcationLevelForm((prevForm) => ({ ...prevForm, VotingDistictID: selectedEvent?.eventDelimitationId }));
		} else if (selectedEvent.eventDelimitationLevelId == 4) {
			GetPollingStaionByNationalVotingStation(id);
			setDemarcationLevelForm((prevForm) => ({ ...prevForm, VotingStationID: selectedEvent?.eventDelimitationId }));
		} else if (selectedEvent.eventDelimitationLevelId == 6) {
			setDemarcationLevelForm((prevForm) => ({ ...prevForm, PollingStationID: selectedEvent?.eventDelimitationId }));
		}
	}
	function GetPreselectedLocalDelimitationOnOpen(id) {
		if (selectedEvent.eventDelimitationLevelId == 1) {
			GetLocalCouncilsByDistrictIdAsync(id);
			setDemarcationLevelForm((prevForm) => ({ ...prevForm, DistrictID: selectedEvent?.eventDelimitationId }));
		} else if (selectedEvent.eventDelimitationLevelId == 2) {
			GetLocalVitingDistrictByConstituencID(id);
			setDemarcationLevelForm((prevForm) => ({ ...prevForm, ConstituencyID: selectedEvent?.eventDelimitationId }));
		} else if (selectedEvent.eventDelimitationLevelId == 3) {
			GetLocalVotingStationByVotingDistrictID(id);
			setDemarcationLevelForm((prevForm) => ({ ...prevForm, VotingStationID: selectedEvent?.eventDelimitationId }));
		} else if (selectedEvent.eventDelimitationLevelId == 4) {
			GetPollingStaionByLocalVotingStation(id);
			setDemarcationLevelForm((prevForm) => ({ ...prevForm, VotingStationID: selectedEvent?.eventDelimitationId }));
		} else if (selectedEvent.eventDelimitationLevelId == 6) {
			setDemarcationLevelForm((prevForm) => ({ ...prevForm, PollingStationID: selectedEvent?.eventDelimitationId }));
		}
	}
	function GetByElectionParentEvent(id) {
		eventService
			.GetEventByID(selectedEvent?.parentEventID)
			.then((response) => {
				setParentEvent(response);

				if (response?.eventTypeID == 1 || response?.eventTypeID == 4) {
					GetPreselectedNationalDelimitationOnOpen(id);
				} else if (response?.eventTypeID == 2) {
					GetPreselectedLocalDelimitationOnOpen(id);
				}
			})
			.catch((err) => {});
	}
	function GetVotingDistrictByConstituencyID(id) {
		delimitationService
			.getPollingDivisionsByConstituency(id)
			.then((response) => {
				setVotingDistricts(response);
			})
			.catch((err) => {});
	}
	function GetLocalVitingDistrictByConstituencID(id) {
		delimitationService
			.GetLocalVotingDistrictsByCouncilIdAsync(id)
			.then((response) => {
				setVotingDistricts(response);
			})
			.catch((err) => {});
	}
	function GetNationalConstituencyByDistrictIdAsync(id) {
		delimitationService
			.getConstituenciesByDistrict(id)
			.then((response) => {
				setConstituences(response);
			})
			.catch((err) => {});
	}
	function GetLocalCouncilsByDistrictIdAsync(id) {
		delimitationService
			.getCouncilsByDistrict(id)
			.then((response) => {
				setConstituences(response);
			})
			.catch((err) => {});
	}

	function DistrictChange(e) {
		setForm((prevForm) => ({ ...prevForm, DelimitationLevelID: 1 }));
		if (selectedEvent?.eventTypeID == 1 || selectedEvent?.eventTypeID == 4) {
			GetNationalConstituencyByDistrictIdAsync(e.target.value);
		} else if (selectedEvent?.eventTypeID == 2) {
			GetLocalCouncilsByDistrictIdAsync(e.target.value);
		} else if (selectedEvent?.eventTypeID == 3) {
			GetByElectionParentEvent(e.target.value);
		}
		setDemarcationLevelForm((prevForm) => ({
			...prevForm,
			DistrictID: e.target.value,
			ConstituencyID: "",
			VotingDistictID: "",
			VotingStationID: "",
			PollingStationID: ""
		}));
		setForm((prevForm) => ({ ...prevForm, DelimitationID: e.target.value }));
	}
	function CostituencyOrCouncilChange(e) {
		setForm((prevForm) => ({ ...prevForm, DelimitationLevelID: 2 }));
		if (selectedEvent?.eventTypeID == 1 || selectedEvent?.eventTypeID == 4) {
			GetVotingDistrictByConstituencyID(e.target.value);
		} else if (selectedEvent?.eventTypeID == 2) {
			GetLocalVitingDistrictByConstituencID(e.target.value);
		} else if (selectedEvent?.eventTypeID == 3) {
			GetByElectionParentEvent(e.target.value);
		}

		setDemarcationLevelForm((prevForm) => ({
			...prevForm,
			ConstituencyID: e.target.value,
			VotingDistictID: "",
			VotingStationID: "",
			PollingStationID: ""
		}));
		setForm((prevForm) => ({ ...prevForm, DelimitationID: e.target.value }));
	}
	function VotingDistrictChangeChange(e) {
		setForm((prevForm) => ({ ...prevForm, DelimitationLevelID: 3 }));
		if (selectedEvent?.eventTypeID == 1 || selectedEvent?.eventTypeID == 4) {
			GetVotingStationByVotingDistrictID(e.target.value);
		} else if (selectedEvent?.eventTypeID == 2) {
			GetLocalVotingStationByVotingDistrictID(e.target.value);
		} else if (selectedEvent?.eventTypeID == 3) {
			console.log(parentEvent);

			if (parentEvent?.eventTypeID == 1 || parentEvent?.eventTypeID == 4) {
				GetVotingStationByVotingDistrictID(e.target.value);
			} else if (parentEvent?.eventTypeID == 2) {
				GetLocalVotingStationByVotingDistrictID(e.target.value);
			}
		}
		setDemarcationLevelForm((prevForm) => ({
			...prevForm,
			VotingDistictID: e.target.value,
			VotingStationID: "",
			PollingStationID: ""
		}));
		setForm((prevForm) => ({ ...prevForm, DelimitationID: e.target.value }));
	}
	function VotingStationChange(e) {
		setForm((prevForm) => ({ ...prevForm, DelimitationLevelID: 4 }));
		if (selectedEvent?.eventTypeID == 1 || selectedEvent?.eventTypeID == 4) {
			GetPollingStaionByNationalVotingStation(e.target.value);
		} else if (selectedEvent?.eventTypeID == 2) {
			GetPollingStaionByLocalVotingStation(e.target.value);
		}
		setDemarcationLevelForm((prevForm) => ({
			...prevForm,
			VotingStationID: e.target.value,
			PollingStationID: ""
		}));
		setForm((prevForm) => ({ ...prevForm, DelimitationID: e.target.value }));
	}
	function PollingStationChange(e) {
		setForm((prevForm) => ({ ...prevForm, DelimitationLevelID: 6 }));
		setDemarcationLevelForm((prevForm) => ({
			...prevForm,
			PollingStationID: e.target.value
		}));
		setForm((prevForm) => ({ ...prevForm, DelimitationID: e.target.value }));
	}

	function GetVotingStationByVotingDistrictID(id) {
		delimitationService
			.getRegistrationCentresByPollingDivision(id)
			.then((response) => {
				setVotingStations(response);
			})
			.catch((err) => {});
	}
	function GetLocalVotingStationByVotingDistrictID(id) {
		delimitationService
			.GetLocalVotingStationByElectorDivisionIDAsync(id)
			.then((response) => {
				setVotingStations(response);
			})
			.catch((err) => {});
	}

	function GetPollingStaionByNationalVotingStation(id) {
		delimitationService
			.getPollingStaionByNationalVotingStation(id)
			.then((response) => {
				setPolingStations(response);
			})
			.catch((err) => {});
	}
	function GetPollingStaionByLocalVotingStation(id) {
		delimitationService
			.getPollingStaionByLocalVotingStation(id)
			.then((response) => {
				setPolingStations(response);
			})
			.catch((err) => {});
	}
	function DemarcationLevelChange(e) {
		if (e.target.value == 1) {
			setDemarcationLevelForm((prevForm) => ({
				...prevForm,
				ConstituencyID: "",
				VotingDistictID: "",
				VotingStationID: "",
				PollingStationID: ""
			}));
		} else if (e.target.value == 2) {
			setDemarcationLevelForm((prevForm) => ({
				...prevForm,
				VotingDistictID: "",
				VotingStationID: "",
				PollingStationID: ""
			}));
		} else if (e.target.value == 3) {
			setDemarcationLevelForm((prevForm) => ({
				...prevForm,
				VotingStationID: "",
				PollingStationID: ""
			}));
		} else if (e.target.value == 4) {
			setDemarcationLevelForm((prevForm) => ({
				...prevForm,
				PollingStationID: ""
			}));
		}
		setDemarcationLevelForm((prevForm) => ({
			...prevForm,
			DelimitationLevelID: e.target.value
		}));
	}
	function DemarcationValidation() {
		let firstErrorKey = null;

		if (!form?.DelimitationLevelID && !isSpecificDelimitation) {
			setDemarcationLevelFormErr((preForm) => ({ ...preForm, DelimitationLevelID: "Required." }));
			firstErrorKey = "DelimitationLevelID";
		}

		if (!firstErrorKey && form.DelimitationLevelID == 1 && !demarcationLevelForm?.DistrictID && !isSpecificDelimitation) {
			setDemarcationLevelFormErr((preForm) => ({ ...preForm, DistrictID: "Required." }));
			firstErrorKey = "DistrictID";
		}

		if (!firstErrorKey && form.DelimitationLevelID == 2 && !demarcationLevelForm?.ConstituencyID) {
			setDemarcationLevelFormErr((preForm) => ({ ...preForm, ConstituencyID: "Required." }));
			firstErrorKey = "ConstituencyID";
		}

		if (!firstErrorKey && form.DelimitationLevelID == 3 && !demarcationLevelForm?.VotingDistictID) {
			setDemarcationLevelFormErr((preForm) => ({ ...preForm, VotingDistictID: "Required." }));
			firstErrorKey = "VotingDistictID";
		}

		if (!firstErrorKey && form.DelimitationLevelID == 4 && !demarcationLevelForm?.VotingStationID) {
			setDemarcationLevelFormErr((preForm) => ({ ...preForm, VotingStationID: "Required." }));
			firstErrorKey = "VotingStationID";
		}

		if (!firstErrorKey && form.DelimitationLevelID == 6 && !demarcationLevelForm?.PollingStationID) {
			setDemarcationLevelFormErr((preForm) => ({ ...preForm, PollingStationID: "Required." }));
			firstErrorKey = "PollingStationID";
		}

		// if there's an error, scroll to it
		if (firstErrorKey && refs[firstErrorKey]?.current) {
			refs[firstErrorKey].current.scrollIntoView({ behavior: "smooth", block: "center" });
		}

		return !firstErrorKey;
	}

	function Submit() {
		setIsSubmitAttempted(true);
		if (DemarcationValidation()) {
			onSubmit();
		}
	}

	const [selectedStaffTypeId, setSelectedStaffTypeId] = useState(null);

	const filteredRoles =
		selectedStaffTypeId === 1 ? lookups?.staffRoles.filter((role) => role.id === 7) : lookups?.staffRoles.filter((role) => role.id !== 7);

	//scroll to the first error
	// refs for scrolling
	const refs = {
		DelimitationLevelID: useRef(null),
		DistrictID: useRef(null),
		ConstituencyID: useRef(null),
		VotingDistictID: useRef(null),
		VotingStationID: useRef(null),
		PollingStationID: useRef(null),
		Firstname: useRef(null),
		Surname: useRef(null),
		IDNumber: useRef(null),
		RegistrationNumber: useRef(null)
	};

	function DemarcationValidation() {
		let firstErrorKey = null;

		if (!form?.DelimitationLevelID && !isSpecificDelimitation) {
			setDemarcationLevelFormErr((preForm) => ({ ...preForm, DelimitationLevelID: "Required." }));
			firstErrorKey = "DelimitationLevelID";
		}

		if (!firstErrorKey && form.DelimitationLevelID == 1 && !demarcationLevelForm?.DistrictID && !isSpecificDelimitation) {
			setDemarcationLevelFormErr((preForm) => ({ ...preForm, DistrictID: "Required." }));
			firstErrorKey = "DistrictID";
		}

		if (!firstErrorKey && form.DelimitationLevelID == 2 && !demarcationLevelForm?.ConstituencyID) {
			setDemarcationLevelFormErr((preForm) => ({ ...preForm, ConstituencyID: "Required." }));
			firstErrorKey = "ConstituencyID";
		}

		if (!firstErrorKey && form.DelimitationLevelID == 3 && !demarcationLevelForm?.VotingDistictID) {
			setDemarcationLevelFormErr((preForm) => ({ ...preForm, VotingDistictID: "Required." }));
			firstErrorKey = "VotingDistictID";
		}

		if (!firstErrorKey && form.DelimitationLevelID == 4 && !demarcationLevelForm?.VotingStationID) {
			setDemarcationLevelFormErr((preForm) => ({ ...preForm, VotingStationID: "Required." }));
			firstErrorKey = "VotingStationID";
		}

		if (!firstErrorKey && form.DelimitationLevelID == 6 && !demarcationLevelForm?.PollingStationID) {
			setDemarcationLevelFormErr((preForm) => ({ ...preForm, PollingStationID: "Required." }));
			firstErrorKey = "PollingStationID";
		}

		// if there's an error, scroll to it
		if (firstErrorKey && refs[firstErrorKey]?.current) {
			refs[firstErrorKey].current.scrollIntoView({ behavior: "smooth", block: "center" });
		}

		return !firstErrorKey;
	}

	function Submit() {
		setIsSubmitAttempted(true);
		if (DemarcationValidation()) {
			onSubmit();
		}
	}

	return (
		<Dialog
			draggable={true}
			header={
				<>
					<span>Add Staff</span>
				</>
			}
			footer={
				<>
					<Button
						label="Close"
						onClick={() => {
							setShow(false);
							setForm({});
						}}
						className="p-button-danger"
					/>
					<Button label="Submit" onClick={Submit} className="p-button-success" type="submit" />
				</>
			}
			visible={show}
			onHide={(e) => {
				setForm({});
				setShow(false);
			}}
			style={{ width: "100%", height: "100%" }}
		>
			<ScreenLoader visible={screenLoading} />
			<div className="grid">
				<div className="col-12 lg:col-12">
					<form>
						<section className="p-4 border rounded bg-gray-100">
							<h2 className="text-xl font-bold">Demarcation Details</h2>
							<div className="grid">
								{!isSpecificDelimitation && (
									<div className="col-12  lg:col-4">
										<label>Demarcation Level</label>
										<Dropdown
											optionLabel="name"
											optionValue="delimitationLevelID"
											onChange={(e) => {
												DemarcationLevelChange(e);
											}}
											options={demarcationLevels.filter(
												(e) =>
													e?.type == selectedEvent?.eventTypeID ||
													e?.type == parentEvent?.eventTypeID ||
													(selectedEvent?.eventTypeID == 4 && e?.type == 1)
											)}
											value={demarcationLevelForm.DelimitationLevelID}
											placeholder="Demarcation Level"
											style={{ width: "100%" }}
										/>
										<label style={{ color: "red", marginBottom: "5px" }}>{demarcationLevelFormErr?.DelimitationLevelID}</label>
									</div>
								)}

								{((!isSpecificDelimitation && demarcationLevelForm?.DelimitationLevelID) ||
									(isSpecificDelimitation && demarcationLevelForm?.DelimitationLevelID == 1)) && (
									<div className="col-12  lg:col-4">
										<label>District</label>
										<Dropdown
											disabled={isSpecificDelimitation && demarcationLevelForm?.DelimitationLevelID == 1}
											optionLabel="name"
											itemTemplate={(option) => (
												<div>
													{option.code} - {option.name}
												</div>
											)}
											optionValue="id"
											onChange={(e) => DistrictChange(e)}
											options={distrcts}
											value={demarcationLevelForm.DistrictID}
											placeholder="Districts"
											style={{ width: "100%" }}
										/>
										<label style={{ color: "red", marginBottom: "5px" }}>{demarcationLevelFormErr?.DistrictID}</label>
									</div>
								)}
								{((!isSpecificDelimitation && demarcationLevelForm?.DelimitationLevelID >= 2) ||
									(demarcationLevelForm?.DelimitationLevelID <= 2 && isSpecificDelimitation)) && (
									<div className="col-12  lg:col-4">
										<label>
											{selectedEvent?.eventTypeID == 1 || selectedEvent?.eventTypeID == 4 || parentEvent?.eventTypeID == 1
												? changeLang.get("national_delimitation.level2ConstituencyCouncil")
												: changeLang.get("local_delimitation.level2ConstituencyCouncil")}
										</label>
										<Dropdown
											disabled={isSpecificDelimitation && demarcationLevelForm?.DelimitationLevelID == 2}
											optionLabel="name"
											itemTemplate={(option) => (
												<div>
													{option.code} - {option.name}
												</div>
											)}
											optionValue="id"
											onChange={(e) => CostituencyOrCouncilChange(e)}
											options={constituences}
											value={demarcationLevelForm.ConstituencyID}
											placeholder={
												selectedEvent?.eventTypeID == 1 || selectedEvent?.eventTypeID == 4 || parentEvent?.eventTypeID == 1
													? changeLang.get("national_delimitation.level2ConstituencyCouncil")
													: changeLang.get("local_delimitation.level2ConstituencyCouncil")
											}
											style={{ width: "100%" }}
										/>
										<label style={{ color: "red", marginBottom: "5px" }}>{demarcationLevelFormErr?.ConstituencyID}</label>
									</div>
								)}
								{((!isSpecificDelimitation && demarcationLevelForm?.DelimitationLevelID >= 3) ||
									(demarcationLevelForm?.DelimitationLevelID <= 3 && isSpecificDelimitation)) && (
									<div className="col-12  lg:col-4">
										<label>
											{selectedEvent?.eventTypeID == 1 || selectedEvent?.eventTypeID == 4 || parentEvent?.eventTypeID == 1
												? changeLang.get("national_delimitation.level3PollingElectorDivision")
												: changeLang.get("local_delimitation.level3PollingElectorDivision")}
										</label>
										<Dropdown
											disabled={isSpecificDelimitation && demarcationLevelForm?.DelimitationLevelID == 3}
											optionLabel="name"
											itemTemplate={(option) => (
												<div>
													{option.code} - {option.name}
												</div>
											)}
											optionValue="id"
											onChange={(e) => VotingDistrictChangeChange(e)}
											options={votingDistricts}
											value={demarcationLevelForm.VotingDistictID}
											placeholder={
												selectedEvent?.eventTypeID == 1 || selectedEvent?.eventTypeID == 4 || parentEvent?.eventTypeID == 1
													? changeLang.get("national_delimitation.level3PollingElectorDivision")
													: changeLang.get("national_delimitation.level3PollingElectorDivision")
											}
											style={{ width: "100%" }}
										/>
										<label style={{ color: "red", marginBottom: "5px" }}>{demarcationLevelFormErr?.VotingDistictID}</label>
										<label style={{ color: "red", marginBottom: "5px" }}>{formErrorMessage?.DelimitationID}</label>
									</div>
								)}
								{((!isSpecificDelimitation && demarcationLevelForm?.DelimitationLevelID >= 4) ||
									(demarcationLevelForm?.DelimitationLevelID <= 4 && isSpecificDelimitation)) && (
									<div className="col-12  lg:col-4">
										<label>
											{selectedEvent?.eventTypeID == 1 || selectedEvent?.eventTypeID == 4 || parentEvent?.eventTypeID == 1
												? changeLang.get("national_delimitation.level4RegistrationCentre")
												: changeLang.get("local_delimitation.level4RegistrationCentre")}
										</label>
										<Dropdown
											disabled={isSpecificDelimitation && demarcationLevelForm?.DelimitationLevelID == 4}
											optionLabel="name"
											itemTemplate={(option) => (
												<div>
													{option.code} - {option.name}
												</div>
											)}
											optionValue="id"
											onChange={(e) => {
												OnInputValidation("DelimitationID", e.target.value);
												VotingStationChange(e);
											}}
											options={votingStations?.filter(
												(station, index, self) => index === self.findIndex((s) => s.id === station.id) // 👈 unique by id
											)}
											value={demarcationLevelForm.VotingStationID}
											placeholder={
												selectedEvent?.eventTypeID == 1 || selectedEvent?.eventTypeID == 4 || parentEvent?.eventTypeID == 1
													? changeLang.get("national_delimitation.level4RegistrationCentre")
													: changeLang.get("local_delimitation.level4RegistrationCentre")
											}
											style={{ width: "100%" }}
										/>

										<label style={{ color: "red", marginBottom: "5px" }}>{demarcationLevelFormErr?.VotingStationID}</label>
										<label style={{ color: "red", marginBottom: "5px" }}>{formErrorMessage?.DelimitationID}</label>
									</div>
								)}
								{((!isSpecificDelimitation && demarcationLevelForm?.DelimitationLevelID >= 6) ||
									(demarcationLevelForm?.DelimitationLevelID <= 6 && isSpecificDelimitation)) && (
									<div className="col-12  lg:col-4">
										<label>
											{selectedEvent?.eventTypeID == 1 || selectedEvent?.eventTypeID == 4 || parentEvent?.eventTypeID == 1
												? changeLang.get("national_delimitation.level6PollingStation")
												: changeLang.get("local_delimitation.level6PollingStation")}
										</label>
										<Dropdown
											disabled={isSpecificDelimitation && demarcationLevelForm?.DelimitationLevelID == 6}
											optionLabel="name"
											itemTemplate={(option) => (
												<div>
													{option.code} - {option.name}
												</div>
											)}
											optionValue="id"
											onChange={(e) => {
												OnInputValidation("DelimitationID", e.target.value);
												PollingStationChange(e);
											}}
											options={polingStations}
											value={demarcationLevelForm.PollingStationID}
											placeholder={
												selectedEvent?.eventTypeID == 1 || selectedEvent?.eventTypeID == 4 || parentEvent?.eventTypeID == 1
													? changeLang.get("national_delimitation.level6PollingStation")
													: changeLang.get("local_delimitation.level6PollingStation")
											}
											style={{ width: "100%" }}
										/>
										<label style={{ color: "red", marginBottom: "5px" }}>{demarcationLevelFormErr?.PollingStationID}</label>
									</div>
								)}
							</div>
						</section>
						<section className="p-4 border rounded bg-gray-100">
							<h2 className="text-xl font-bold">Staff Details</h2>
							<div className="grid">
								<div className="col-12  lg:col-4">
									<TextInput
										label="First Name"
										ref={refs.Firstname}
										value={form.Firstname}
										onChange={(e) => {
											OnInputValidation("Firstname", e.target.value);
											setForm({ ...form, Firstname: e.target.value });
										}}
									/>
									<label style={{ color: "red", marginBottom: "5px" }}>{formErrorMessage?.Firstname}</label>
								</div>
								<div className="col-12  lg:col-4">
									<TextInput
										label="Surname"
										ref={refs.Surname}
										value={form.Surname}
										onChange={(e) => {
											OnInputValidation("Surname", e.target.value);
											setForm({ ...form, Surname: e.target.value });
										}}
									/>
									<label style={{ color: "red", marginBottom: "5px" }}>{formErrorMessage?.Surname}</label>
								</div>
								<div className="col-12  lg:col-4">
									<TextInput
										label="ID Number"
										ref={refs.IDNumber}
										value={form.IDNumber}
										onChange={(e) => {
											OnInputValidation("IDNumber", e.target.value);
											setForm({ ...form, IDNumber: e.target.value });
										}}
										disabled
									/>
									<label style={{ color: "red", marginBottom: "5px" }}>{formErrorMessage?.IDNumber}</label>
								</div>
								<div className="col-12  lg:col-4">
									<TextInput
										label="Registration Number"
										value={form.RegistrationNumber}
										onChange={(e) => {
											OnInputValidation("RegistrationNumber", e.target.value);
											setForm({ ...form, RegistrationNumber: e.target.value });
										}}
										disabled
									/>
									<label style={{ color: "red", marginBottom: "5px" }}>{formErrorMessage?.RegistrationNumber}</label>
								</div>
								<div className="col-12  lg:col-4">
									<label>
										Address <span className="text-error">*</span>
									</label>
									<TextInput
										ref={refs.Address}
										value={form.Address}
										onChange={(e) => {
											OnInputValidation("Address", e.target.value);
											setForm({ ...form, Address: e.target.value });
										}}
									/>
									<label style={{ color: "red", marginBottom: "5px" }}>{formErrorMessage?.Address}</label>
								</div>
								<div className="col-12  lg:col-4">
									<label>
										Date Appointed <span className="text-error">*</span>
									</label>
									<Calendar
										ref={refs.DateAppointed}
										style={{ width: "100%" }}
										placeholder="dd/mm/yy"
										dateFormat="dd/mm/yy"
										value={form.DateAppointed}
										showTime={false}
										showIcon={true}
										onChange={(e) => {
											OnInputValidation("DateAppointed", e.target.value);
											setForm({ ...form, DateAppointed: e.target.value });
										}}
									/>
									<label style={{ color: "red", marginBottom: "5px" }}>{formErrorMessage?.DateAppointed}</label>
								</div>
								<div className="col-12  lg:col-4">
									<label>
										Gender <span className="text-error">*</span>{" "}
									</label>
									<Dropdown
										optionLabel="name"
										onChange={(e) => {
											OnInputValidation("GenderID", e.target.value);
											setForm({ ...form, GenderID: e.value });
										}}
										options={lookups?.genders}
										optionValue="id"
										value={form?.GenderID}
										placeholder="Gender"
										style={{ width: "100%" }}
									/>
									<label style={{ color: "red", marginBottom: "5px" }}>{formErrorMessage?.GenderID}</label>
								</div>
							</div>
						</section>
						<section className="p-4 border rounded bg-gray-100">
							<h2 className="text-xl font-bold">Duty Details</h2>
							<div className="grid">
								<div className="col-12 lg:col-4">
									<label>Staff Type</label>
									<Dropdown
										value={form.StaffTypeID}
										options={lookups.staffTypes}
										optionLabel="name"
										optionValue="id"
										placeholder="Select Staff Type"
										onChange={(e) => {
											setSelectedStaffTypeId(e.value);
											OnInputValidation("StaffTypeID", e.value);
											setForm({ ...form, StaffTypeID: e.value });
										}}
										style={{ width: "100%" }}
									/>
									<label style={{ color: "red", marginBottom: "5px" }}>{formErrorMessage?.StaffTypeID}</label>
								</div>

								<div className="col-12  lg:col-4">
									<label>
										Staff Role <span className="text-error">*</span>
									</label>
									<Dropdown
										optionLabel="name"
										onChange={(e) => {
											OnInputValidation("RoleId", e.target.value);
											setForm({
												...form,
												RoleId: e.value
											});
										}}
										options={filteredRoles}
										optionValue="id"
										value={form?.RoleId}
										placeholder="Staff Role"
										style={{ width: "100%" }}
									/>
									<label style={{ color: "red", marginBottom: "5px" }}>{formErrorMessage?.RoleId}</label>
								</div>

								<div className="col-12  lg:col-4">
									<label>
										Start Date <span className="text-error">*</span>
									</label>
									<Calendar
										style={{ width: "100%" }}
										placeholder="dd/mm/yy"
										value={form.StartDate}
										maxDate={form.EndDate || null}
										showTime={false}
										showIcon={true}
										dateFormat="dd/mm/yy"
										onChange={(e) => {
											const startDate = e.target.value;
											OnInputValidation("StartDate", startDate);

											setForm((prev) => ({
												...prev,
												StartDate: startDate,
												EndDate: prev.EndDate && startDate > prev.EndDate ? null : prev.EndDate
											}));
										}}
									/>
									<label style={{ color: "red", marginBottom: "5px" }}>{formErrorMessage?.StartDate}</label>
								</div>
								<div className="col-12  lg:col-4">
									<label>
										End Date <span className="text-error">*</span>
									</label>
									<Calendar
										style={{ width: "100%" }}
										placeholder="dd/mm/yy"
										value={form.EndDate}
										minDate={form.StartDate || null}
										showTime={false}
										showIcon={true}
										dateFormat="dd/mm/yy"
										onChange={(e) => {
											const endDate = e.value;

											OnInputValidation("EndDate", endDate);
											setForm((prev) => ({
												...prev,
												EndDate: endDate,
												StartDate: prev.StartDate && endDate < prev.StartDate ? null : prev.StartDate
											}));
										}}
									/>
									<label style={{ color: "red", marginBottom: "5px" }}>{formErrorMessage?.EndDate}</label>
								</div>
							</div>
						</section>
						<section className="p-4 border rounded bg-gray-100">
							<h2 className="text-xl font-bold">Contact Details </h2>
							<div className="grid">
								<div className="col-12  lg:col-4">
									<label>
										Contact Number <span className="text-error">*</span>
									</label>
									<TextInput
										value={form.ContactNumber}
										onChange={(e) => {
											OnInputValidation("ContactNumber", e.target.value);
											setForm({ ...form, ContactNumber: e.target.value });
										}}
									/>
									<label style={{ color: "red", marginBottom: "5px" }}>{formErrorMessage?.ContactNumber}</label>
								</div>
								<div className="col-12  lg:col-4">
									<label>Email Address</label>
									<TextInput
										value={form.EmailAddress}
										onChange={(e) => {
											// if (e.target.value.trim().length > 0) {
											// 	OnInputValidation("EmailAddress", e.target.value);
											// }else{
											// 		OnInputValidation("EmailAddress", "test@gmail.com");
											// }

											setForm({ ...form, EmailAddress: e.target.value });
										}}
									/>
									<label style={{ color: "red", marginBottom: "5px" }}>{formErrorMessage?.EmailAddress}</label>
								</div>
							</div>
						</section>
					</form>
				</div>
			</div>
		</Dialog>
	);
}
